import { ReactNode } from 'react';

export interface InputHintProps {
    className?: string;
    hint?: ReactNode;
}

export function InputHint({ className, hint }: InputHintProps): ReactNode {
    if (!hint) {
        return null;
    }

    return <small className={className}>{hint}</small>;
}
